"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonDisconn;
require("core-js/modules/web.dom-collections.iterator.js");
var _MartyBattery = _interopRequireDefault(require("../MartyBattery"));
var _MartySignal = _interopRequireDefault(require("../MartySignal"));
var _disconnectButton = require("../../assets/connector/disconnect-button.svg");
var _martyGraphic = require("../../assets/connector/marty-graphic.svg");
require("./styles.css");
var _react = require("react");
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ButtonDisconn(_ref) {
  let {
    onClick
  } = _ref;
  const [batteryState, setBattery] = (0, _react.useState)(0);
  const [signalState, setSignal] = (0, _react.useState)(-200);
  const [martyNameState, setMartyName] = (0, _react.useState)("");
  (0, _react.useEffect)(() => {
    const connectedRaft = window.applicationManager.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.MARTY);
    const battAndSignInterval = setInterval(() => {
      if (!connectedRaft) {
        return;
      }
      onBatteryChangeListener({
        battery: connectedRaft.getBatteryStrength()
      });
      onSignalChangeListener({
        rssi: connectedRaft.getRSSI()
      });
      onMartyNameChangeListener({
        martyName: connectedRaft.getFriendlyName() || ""
      });
    }, 200);
    return () => {
      clearInterval(battAndSignInterval);
    };
  }, []);
  const onSignalChangeListener = _ref2 => {
    let {
      rssi
    } = _ref2;
    setSignal(rssi);
  };
  const onMartyNameChangeListener = _ref3 => {
    let {
      martyName
    } = _ref3;
    setMartyName(martyName);
  };
  const onBatteryChangeListener = _ref4 => {
    let {
      battery
    } = _ref4;
    setBattery(battery);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "button-disconn-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "button-disconn-title",
      children: martyNameState
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "button-disconn-battery-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MartyBattery.default, {
        batteryStrength: batteryState
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "button-disconn-signal-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MartySignal.default, {
        signalStrength: signalState
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "button-disconn-disconnect-btn-container",
      onClick: onClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_disconnectButton.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "button-disconn-marty-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_martyGraphic.ReactComponent, {})
    })]
  });
}